import Vue from 'vue';
import Vuex from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agents from './modules/agents';
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import auth from './modules/auth';
import auditlogs from './modules/auditlogs';
import webhooksSendMessagesLogs from './modules/webhooksSendMessagesLogs';
import automations from './modules/automations';
import bots from './modules/bots';
import bulkActions from './modules/bulkActions';
import webhooksSendMessages from './modules/webhooksSendMessages';
import campaigns from './modules/campaigns';
import cannedResponse from './modules/cannedResponse';
import agentBotManagement from './modules/agentBotManagement';
import categories from './modules/helpCenterCategories';
import closingReasons from './modules/closingReasons';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contacts from './modules/contacts';
import conversationLabels from './modules/conversationLabels';
import conversationProductLabels from './modules/conversationProductLabels';
import conversationTopicLabels from './modules/conversationTopicLabels';
import conversationConcurrentLabels from './modules/conversationConcurrentLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationsExport from './modules/conversationsExport';
import conversationSearch from './modules/conversationSearch';
import internalChatSearch from './modules/internalChatSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationWatchers from './modules/conversationWatchers';
import csat from './modules/csat';
import customViews from './modules/customViews';
import dashboardApps from './modules/dashboardApps';
import operationalDashboard from './modules/operationalDashboard';
import globalConfig from 'shared/store/globalConfig';
import historyClosingReasons from './modules/historyClosingReasons';
import historyCtwaCampaigns from './modules/historyCtwaCampaigns';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxClosingReasons from './modules/inboxClosingReasons';
import inboxMigrations from './modules/inboxMigrations';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import internalChat from './modules/internalChat';
import labels from './modules/labels';
import productLabels from './modules/productLabels';
import topicLabels from './modules/topicLabels';
import concurrentLabels from './modules/concurrentLabels';
import macros from './modules/macros';
import notifications from './modules/notifications';
import observerMode from './modules/observerMode';
import opportunities from './modules/opportunities';
import opportunityPipelines from './modules/opportunityPipelines';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import scheduledMessages from './modules/scheduledMessages';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import templateParameterizations from './modules/templateParameterizations';
import userNotificationSettings from './modules/userNotificationSettings';
import whatsappTemplates from './modules/whatsappTemplates';
import webhooks from './modules/webhooks';
import assistent from './modules/assistent';
import publicKnowledgeBases from './modules/publicKnowledgeBases';
import cadencias from './modules/cadencias';
import syonetConnections from './modules/syonetConnections';
import events from './modules/events';
import call from './modules/call';
import subaccounts from './modules/subaccounts';
import bulkActionsSettings from './modules/bulkActionsSettings';

import LogRocket from 'logrocket';
import createPlugin from 'logrocket-vuex';

import userAccountsAccess from './modules/userAccountsAccess';

const plugins = [];

if (window.logRocketProjectId) {
  LogRocket.init(window.logRocketProjectId);
  const logRocketPlugin = createPlugin(LogRocket, function(mutation) {
    const eventsToIgnore = ['SET_CURRENT_USER', 'AUTHENTICATE', 'CLEAR_USER'];
    if (eventsToIgnore.includes(mutation.type)) {
      return null;
    }

    return mutation;
  });

  plugins.push(logRocketPlugin);
}

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    accounts,
    agentBots,
    agents,
    articles,
    attributes,
    auth,
    automations,
    auditlogs,    
    bots,
    bulkActions,
    webhooksSendMessages,
    webhooksSendMessagesLogs,
    campaigns,
    cannedResponse,
    agentBotManagement,
    categories,
    closingReasons,
    contactConversations,
    contactLabels,
    contactNotes,
    contacts,
    conversationLabels,
    conversationProductLabels,
    conversationTopicLabels,
    conversationConcurrentLabels,
    conversationMetadata,
    conversationPage,
    conversations,
    conversationsExport,
    conversationSearch,
    internalChatSearch,
    conversationStats,
    conversationTypingStatus,
    conversationWatchers,
    csat,
    customViews,
    dashboardApps,
    globalConfig,
    historyClosingReasons,
    historyCtwaCampaigns,
    inboxAssignableAgents,
    inboxes,
    inboxClosingReasons,
    inboxMigrations,
    inboxMembers,
    integrations,
    internalChat,
    labels,
    productLabels,
    topicLabels,
    concurrentLabels,
    macros,
    notifications,
    observerMode,
    operationalDashboard,
    opportunities,
    opportunityPipelines,
    portals,
    reports,
    scheduledMessages,
    teamMembers,
    teams,
    templateParameterizations,
    userNotificationSettings,
    whatsappTemplates,
    webhooks,
    userAccountsAccess,
    assistent,
    publicKnowledgeBases,
    cadencias,
    syonetConnections,
    events,
    call,
    subaccounts,
    bulkActionsSettings,
  },
  plugins,
});
